import { z } from 'zod';
import { allowedMimeEnum, assetEntityTypeEnum } from './enums.ts';

/**
 * Asset wire shape. The Worker validates `meta` (the JSON sidecar in
 * a multipart upload) with this schema, and the web client builds the
 * upload form from the same fields.
 *
 * The 8 MB cap on `file.size` is enforced in the route, not here —
 * Zod can't see the binary part.
 */

export const assetTagInput = z.string().min(1).max(40);
export type AssetTagInput = z.infer<typeof assetTagInput>;

export const createAssetMeta = z.object({
  domainId: z.string().nullable().optional(),
  zoneId: z.string().nullable().optional(),
  entityType: assetEntityTypeEnum.nullable().optional(),
  entityId: z.string().nullable().optional(),
  caption: z.string().max(500).nullable().optional(),
  takenAt: z.string().nullable().optional(),
  tags: z.array(assetTagInput).default([]),
});
export type CreateAssetMeta = z.infer<typeof createAssetMeta>;

export const patchAssetMeta = z.object({
  caption: z.string().max(500).nullable().optional(),
  takenAt: z.string().nullable().optional(),
  tags: z.array(assetTagInput).optional(),
});
export type PatchAssetMeta = z.infer<typeof patchAssetMeta>;

export { allowedMimeEnum };
